// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xJJr0","newExpiryDate":"styles_newExpiryDate__2SVYd","footer":"styles_footer__3t3f_"};